module.exports = __webpack_public_path__ + "img/p06.96269a8c.jpg";